import { Entgeltart } from '../../contracts/enums/Entgeltart.js';
import { Lohnart } from '../../contracts/enums/Lohnart.js';
import type { SalaryKeyRecord } from '../../salary-table/api/salary-table-operations.js';
import type { LodasPersonData } from '../../server/lodas/LodasPersonData.js';
import { calculateSalary } from '../../server/lodas/transformers.js';
import { getIncrement } from './generateLohnart.js';

export async function generateSalary(
  satzNummer: string,
  persons: LodasPersonData[],
  generateNetto = false,
  cachedSalary?: SalaryKeyRecord,
) {
  const mappedLine: string[] = [];

  for (const person of persons) {
    let lodasID = 1;

    if (!person.salaryInformation.length) continue;
    for (let i = 0; i < person.salaryInformation.length; i++) {
      const info = person.salaryInformation[i];
      if (!info) continue;

      if (generateNetto) {
        if (info.jobticket) {
          mappedLine.push(`${satzNummer};"${person.personalNr}";"${person.lodasPersonalNr}";${lodasID};9010;-34,30;`);
          lodasID++;
        }
        continue;
      }

      // hardcoded values for the jobticket. These may change in the future
      if (info.jobticket) {
        mappedLine.push(`${satzNummer};"${person.personalNr}";"${person.lodasPersonalNr}";${lodasID};319;12,25;`);
        lodasID++;
      }

      // Persons within this group get no salary exported (persons with atz)
      if (person.personenGruppe === '103') continue;

      // salaray from tariftable
      if (
        info.erfahrungstufe &&
        info.tarifGruppe &&
        info.entgeltart === Entgeltart.FESTGEHALT_MONATSLOHN_TARIFGEBUNDEN
      ) {
        const inc = getIncrement(info.tarifGruppe, info.erfahrungstufe - 1);
        if (inc === 0) continue;

        const pay = await calculateSalary(
          info.tarifGruppe,
          info.erfahrungstufe,
          info.woechentlicheArbeitszeit,
          cachedSalary,
        );

        if (pay !== '0,0') {
          mappedLine.push(`${satzNummer};"${person.personalNr}";"${person.lodasPersonalNr}";${lodasID};${inc};${pay};`);
          lodasID++;
        }
      }

      // salaray over monthly pay
      if (info.monthlyPay?.length) {
        for (const monthlyPay of info.monthlyPay) {
          const indexOfLohnart = Array.from(Object.values(Lohnart)).findIndex(l => l === monthlyPay.lohnart);
          if (indexOfLohnart === -1)
            throw new Error('Could not find Lohnart ' + monthlyPay.lohnart + ' on person ' + person.personalNr);

          const pay = monthlyPay.betrag;
          if (pay) {
            mappedLine.push(
              `${satzNummer};"${person.personalNr}";"${person.lodasPersonalNr}";${lodasID};${
                indexOfLohnart + 3000
              };${pay.toFixed(2).replaceAll('.', ',')};`,
            );
            lodasID++;
          }
        }
      }
    }
  }

  return mappedLine.join('\r\n');
}
